import React from 'react';
import PropTypes from 'prop-types';

import Navigation from 'components/Navigation';

import navItems from './navItems.json';

const AdminNavigation = ({ selectedKey }) => (
  <Navigation
    subtitle={'admin'}
    items={navItems}
    backTo={'/'}
    selectedKey={selectedKey}
    showHeader
  />
);

AdminNavigation.propTypes = {
  selectedKey: PropTypes.string,
};

export default AdminNavigation;
